export const WASTE_STREAM_REST = 2;
export const WASTE_STREAM_PAPER = 3;
export const WASTE_STREAM_GFT = 5;
export const WASTE_STREAM_PMD = 6;
export const WASTE_STREAM_TEXTILE = 8;
export const WASTE_STREAM_ABS = 9;
export const WASTE_STREAM_GLAS = 10;
export const WASTE_STREAM_BULK = 11;
export const WASTE_STREAM_RECYCLE = 13;
export const WASTE_STREAM_PESTS = 14;
export const WASTE_STREAM_ELECTRONICS = 57;
export const WASTE_STREAM_KCA = 58;
export const WASTE_STREAM_CLEAN = 59;

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/shared/../../scss/assets/_variables.scss'.
export const SCREEN_MOBILE = 576;
export const SCREEN_TABLET = 768;
export const SCREEN_NORMAL = 992;
export const SCREEN_WIDE = 1240;